import axios from 'axios';

import { axiosHeader, getV1RootUrl } from 'common/helpers/apiHelper';

export const addClubShipmentItem = (customerId, clubMemberShipmentId, item) =>
  axios.post(
    `${getV1RootUrl()}/customer/${customerId}/club-member-shipment/${clubMemberShipmentId}/item`,
    item,
    axiosHeader()
  );

export const exchangeClubShipmentItem = (
  customerId,
  clubMemberShipmentId,
  productVariantId,
  item
) =>
  axios.put(
    `${getV1RootUrl()}/customer/${customerId}/club-member-shipment/${clubMemberShipmentId}/item/${productVariantId}/exchange`,
    item,
    axiosHeader()
  );

export const editClubShipmentItem = (
  customerId,
  clubMemberShipmentId,
  productVariantId,
  item
) =>
  axios.put(
    `${getV1RootUrl()}/customer/${customerId}/club-member-shipment/${clubMemberShipmentId}/item/${productVariantId}`,
    item,
    axiosHeader()
  );

export const deleteClubShipmentItem = (
  customerId,
  clubMemberShipmentId,
  productVariantId
) =>
  axios.delete(
    `${getV1RootUrl()}/customer/${customerId}/club-member-shipment/${clubMemberShipmentId}/item/${productVariantId}`,
    axiosHeader()
  );

export const shipShipmentNow = (customerId, clubMemberShipmentId) =>
  axios.put(
    `${getV1RootUrl()}/customer/${customerId}/club-member-shipment/${clubMemberShipmentId}/ship-now`,
    null,
    axiosHeader()
  );

export const skipClubShipment = (customerId, clubMemberShipmentId) =>
  axios.put(
    `${getV1RootUrl()}/customer/${customerId}/club-member-shipment/${clubMemberShipmentId}/skip`,
    null,
    axiosHeader()
  );

export const unskipClubShipment = (customerId, clubMemberShipmentId) =>
  axios.put(
    `${getV1RootUrl()}/customer/${customerId}/club-member-shipment/${clubMemberShipmentId}/unskip`,
    null,
    axiosHeader()
  );
